
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 8.775l15-6.275-6.283 15H10.4l-2.2-5.7-5.7-2.208v-.817zm8.358 5.275l3.534-8.442L5.95 9.133l2.858 1.109.684.266.266.692 1.1 2.85z","fill":"#9AA0B5"}})])
          )
        }
      }
    